<template>
    <el-button class="export-btn pdf-btn" @click="exportTrigger" v-if="!isPrinting">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256"
            height="256" viewBox="0 0 256 256" xml:space="preserve">
            <g transform="translate(128 128) scale(0.72 0.72)" style="">
                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                    transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)">
                    <path
                        d="M 43.476 51.115 c -0.506 1.171 -1.041 2.343 -1.598 3.505 c 1.265 -0.341 2.54 -0.647 3.811 -0.915 c -0.328 -0.369 -0.652 -0.745 -0.971 -1.13 C 44.289 52.098 43.875 51.611 43.476 51.115 z"
                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    <path
                        d="M 43.721 34.034 c -0.022 -2.083 -0.544 -2.348 -0.921 -2.382 c -0.482 0.098 -0.993 0.363 -1.327 1.283 c -0.638 1.754 -0.279 4.726 1.082 8.072 C 43.308 38.389 43.742 35.995 43.721 34.034 z"
                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    <path
                        d="M 25.174 70.925 c 1.496 -0.417 4.109 -3.502 6.911 -7.831 c -2.218 1.18 -4.078 2.48 -5.367 3.865 C 25.079 68.718 24.947 70.009 25.174 70.925 z"
                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    <path
                        d="M 63.203 57.569 c -1.763 -0.665 -4.363 -0.895 -7.39 -0.757 c 3.991 2.676 7.348 3.506 8.729 3.003 c 0.212 -0.078 0.366 -0.134 0.365 -0.708 C 64.897 58.837 64.832 58.184 63.203 57.569 z"
                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    <path
                        d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 66.059 63.97 c -3.994 1.461 -10.583 -1.267 -16.537 -6.464 c -3.472 0.583 -7.118 1.492 -10.512 2.651 c -3.918 7.018 -8.338 12.876 -11.605 14.562 c -0.868 0.448 -1.73 0.67 -2.542 0.67 c -1.21 0 -2.307 -0.491 -3.143 -1.455 l -0.206 -0.238 l -0.132 -0.286 c -1.434 -3.113 -0.689 -6.475 2.098 -9.467 c 2.746 -2.948 7.3 -5.486 12.475 -7.428 c 1.674 -3.112 3.263 -6.441 4.561 -9.671 c -3.296 -5.596 -4.633 -11.492 -3.202 -15.423 c 0.857 -2.355 2.64 -3.839 5.021 -4.177 l 0.311 -0.022 c 2.651 0 4.554 1.572 5.219 4.311 c 0.808 3.33 -0.314 8.791 -2.465 14.744 c 0.78 1.151 1.67 2.299 2.667 3.409 c 0.952 1.148 1.915 2.189 2.872 3.127 c 5.583 -0.715 10.648 -0.582 13.825 0.617 c 3.876 1.463 4.524 4.121 4.565 5.575 l 0.001 0.044 C 69.35 61.41 68.157 63.203 66.059 63.97 z M 62.35 17.733 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 l 12.611 12.612 H 62.35 z"
                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                </g>
            </g>
        </svg>
    </el-button>
</template>

<script lang="ts">
import { ref } from "vue"

export default {
    props: {
        useBeforePrint: {
            type: Boolean,
            default: () => {
                return false
            }
        }
    },

    emit: ["beforePrint", "afterPrint"],

    setup(props, { emit }) {

        const isPrinting = ref<boolean>(false)

        window.onafterprint = function () {
            emit('afterPrint')
        }

        const exportTrigger = async () => {
            if (props.useBeforePrint) {
                await new Promise(resolve => {
                    emit('beforePrint', resolve)
                })
            }

            isPrinting.value = true
            let header = document.querySelector('header') as HTMLElement
            let content = document.querySelector('#kt_content') as HTMLElement
            let asside = document.querySelector('#kt_aside') as HTMLElement
            let wrapper = document.querySelector('#kt_wrapper') as HTMLElement
            let mobileMenuButton = document.querySelector('#kt_aside_mobile_toggle') as HTMLElement
            let logoHeader = document.querySelector('#make-logo-export') as HTMLElement

            header.style.position = "relative"
            header.style.marginLeft = "0px"
            header.style.width = "100%"
            content.style.margin = "15px 0 0 0"
            asside.style.display = "none"
            wrapper.style.setProperty('margin-left', '0px', 'important')
            logoHeader.style.display = "block"
            mobileMenuButton.style.display = "none"

            setTimeout(() => {
                window.print();

                isPrinting.value = false
                header.removeAttribute('style')
                content.removeAttribute('style')
                asside.removeAttribute('style')
                wrapper.removeAttribute('style')
                logoHeader.style.display = "none"
                mobileMenuButton.style.display = "block"
            }, 300)

        }

        return {
            // data
            isPrinting,

            // methods
            exportTrigger
        }
    }
}
</script>

<style>
@import "../../assets/less/custom-pdf-print/index.css";
</style>